/**
 * The onboarding sample report (CORE-18, ONB-1/2/3/18/19).
 *
 * These JSON files are byte-identical mirrors of
 * `backend/app/data/sample_report/sample_report_{en,tr}.json`, which the
 * backend builds by running the real report post-processing (report quality,
 * C1/C2 policy, enrichment) over the sample's grading inputs. Do not edit them
 * by hand: rebuild with `python -m app.data.sample_report.builder --write`
 * (see that module). Parity with the backend copy is checked by pytest and
 * vitest; the shape is checked by `tsc` through `satisfies` below.
 *
 * TODO: the grading inputs are carried over from the previous hand-authored
 * sample; regenerate them from a real engine run on a fictional transcript.
 */
import type { SampleReportFixture } from '../../types/report';
import sampleEn from './sample_report_en.json';
import sampleTr from './sample_report_tr.json';

const SAMPLE_EN = sampleEn satisfies SampleReportFixture;
const SAMPLE_TR = sampleTr satisfies SampleReportFixture;

export function getSampleReport(language: string | undefined): SampleReportFixture {
  return language === 'tr' ? SAMPLE_TR : SAMPLE_EN;
}
